import React from "react";
import { BrowserRouter, Routes, Route, } from 'react-router-dom'
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AboutUs from "./views/AboutUs";
import AuthLoading from './views/AuthLoading';
import { Provider } from "react-redux";
import ProtectedRoute from './views/ProtectedRoute';
import MyProfile from './views/MyProfile';
import BookingHistory from './views/BookingHistory';
import Dashboard from './views/Dashboard';
import ModernDashboardView from './views/ModernDashboardView';
import ModernLogin from './components/auth/ModernLogin';
import ModernBookingHistory from './views/ModernBookingHistory';
import ModernDashboardComplete from './views/ModernDashboardComplete';
import ModernLayout from './components/layout/ModernLayout';
import { Toaster } from './components/ui/toast';
import CarTypes from './views/CarTypes';
import AddBookings from './views/AddBookings';
import Promos from './views/Promos';
import Users from './views/Users';
import CustomerDetails from "views/CustomerDetails.js";
import Notifications from './views/Notifications';
import Settings from './views/Settings.js';
import Complain from "views/Complain.js";
import AddMoney from "./views/AddMoney";
import Withdraws from './views/Withdraws';
import AllReports from "./views/AllReports";
import { FirebaseProvider, store } from "common";
import { FirebaseConfig } from './config/FirebaseConfig';
import { GoogleMapApiConfig } from './config/GoogleMapApiConfig';
import { GoogleMapApiOptions } from './mapConfig';
import { appcat } from './config/AppCat';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ContactUs from "./views/ContactUs";
import UserWallet from "./views/UserWallet";
import CarsList from "./views/CarsList";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { useJsApiLoader } from '@react-google-maps/api';
import TermCondition from "views/TermCondition.js";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { webClientId } from "config/ClientIds.js";
import { HelmetProvider } from "react-helmet-async";
import Sos from './views/Sos';
import DriverDetails from "views/DriverDetails.js";
import Error from "views/Error.js";
import BookingDetails from "views/BookingDetails.js";
import UserDocuments from "views/UserDocuments.js";
import AddNotifications from "views/AddNotifications.js";
import EditPromo from "views/EditPromo.js";
import EditCar from "views/EditCar.js";
import EditCarType from "views/EditCarType.js";
import EditUser from "views/EditUser.js";
import PaymentSettings from "views/PaymentSettings.js";
import DriverRewardsAndLeague from "views/DriverRewardsAndLeague.js";
import LeagueSettings from "views/LeagueSettings.js";
import DriverMap from "views/DriverMap.js";
import CommunityManagement from "views/CommunityManagement.js";
import BookingQueue from './views/BookingQueue';
// Use the libraries defined in GoogleMapApiOptions
const libraries = GoogleMapApiOptions.libraries;

i18n
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false
    }
  });

function App() {

  useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: GoogleMapApiConfig,
    version: GoogleMapApiOptions.v,
    libraries
  })

  const theme = createTheme()

  return (
    <HelmetProvider>
      <Provider store={store}>
        <FirebaseProvider config={FirebaseConfig} appcat={appcat}>
          <GoogleOAuthProvider clientId={webClientId}>
            <ThemeProvider theme={theme}>
              <AuthLoading>
                <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                  <Toaster />
                  <Routes>
                {/* Modern Routes */}
                <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><ModernDashboardComplete /></ModernLayout></ProtectedRoute>}/>
                <Route path="/bookings" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><ModernLayout><ModernBookingHistory /></ModernLayout></ProtectedRoute>}/>
                <Route path="/booking-queue" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><BookingQueue /></ModernLayout></ProtectedRoute>}/>
                <Route path="/login" element={<ModernLogin />} />
                
                {/* Classic Routes (backup) */}
                <Route path="/dashboard-classic" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><Dashboard /></ModernLayout></ProtectedRoute>}/>
                <Route path="/bookings-classic" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><ModernLayout><BookingHistory /></ModernLayout></ProtectedRoute>}/>
                <Route path="/login-classic" element={<LoginPage />} />
                
                {/* Other Routes */}
                <Route path="/bookings/bookingdetails/:id" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><ModernLayout><BookingDetails /></ModernLayout></ProtectedRoute>}/>
                <Route path="/profile" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><ModernLayout><MyProfile /></ModernLayout></ProtectedRoute>}/>
                <Route path="/cartypes" element={<ProtectedRoute permit={"admin"}><ModernLayout><CarTypes /></ModernLayout></ProtectedRoute>}/>
                <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><ModernLayout><CarsList /></ModernLayout></ProtectedRoute>}/>
                <Route path="/addbookings" element={<ProtectedRoute permit={"admin,fleetadmin,customer"}><ModernLayout><AddBookings /></ModernLayout></ProtectedRoute>}/>
                <Route path="/promos" element={<ProtectedRoute permit={"admin"}><ModernLayout><Promos /></ModernLayout></ProtectedRoute>}/>
                <Route path="/users/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><Users /></ModernLayout></ProtectedRoute>}/>
                <Route path="/users/customerdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><CustomerDetails/></ModernLayout></ProtectedRoute>}/>
                <Route path="/users/driverdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><DriverDetails/></ModernLayout></ProtectedRoute>}/>
                <Route path="/users/userdocuments/:rId/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><UserDocuments/></ModernLayout></ProtectedRoute>} />  
                <Route path="/notifications" element={<ProtectedRoute permit={"admin"}><ModernLayout><Notifications /></ModernLayout></ProtectedRoute>}/>
                <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"}><ModernLayout><AddMoney /></ModernLayout></ProtectedRoute>}/>
                <Route path="/userwallet" element={<ProtectedRoute permit={"customer,driver,fleetadmin"}><ModernLayout><UserWallet /></ModernLayout></ProtectedRoute>}/>
                <Route path="/withdraws" element={<ProtectedRoute permit={"admin"}><ModernLayout><Withdraws /></ModernLayout></ProtectedRoute>}/>
                <Route path="/sos" element={<ProtectedRoute permit={"admin"}><ModernLayout><Sos /></ModernLayout></ProtectedRoute>}/>
                <Route path="/complain" element={<ProtectedRoute permit={"admin"}><ModernLayout><Complain /></ModernLayout></ProtectedRoute>}/>
                <Route path="/allreports" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><AllReports /></ModernLayout></ProtectedRoute>}/>
                <Route path="/settings" element={<ProtectedRoute permit={"admin"}><ModernLayout><Settings /></ModernLayout></ProtectedRoute>}/>
                <Route path="/paymentsettings" element={<ProtectedRoute permit={"admin"}><ModernLayout><PaymentSettings /></ModernLayout></ProtectedRoute>}/>
                <Route path="/driverrewards" element={<ProtectedRoute permit={"admin"}><ModernLayout><DriverRewardsAndLeague /></ModernLayout></ProtectedRoute>}/>
                <Route path="/driverleague" element={<ProtectedRoute permit={"admin"}><ModernLayout><DriverRewardsAndLeague /></ModernLayout></ProtectedRoute>}/>
                <Route path="/leaguesettings" element={<ProtectedRoute permit={"admin"}><ModernLayout><LeagueSettings /></ModernLayout></ProtectedRoute>}/>
                <Route path="/drivermap" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><DriverMap /></ModernLayout></ProtectedRoute>}/>
                <Route path="/community" element={<ProtectedRoute permit={"admin"}><ModernLayout><CommunityManagement /></ModernLayout></ProtectedRoute>}/>
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/term-condition" element={<TermCondition />} />
                <Route path="/users/edituser/:usertype" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><EditUser/></ModernLayout></ProtectedRoute>}/>
                <Route path="/users/edituser/:usertype/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><ModernLayout><EditUser/></ModernLayout></ProtectedRoute>}/>
                <Route path="/notifications/addnotifications" element={<ProtectedRoute permit={"admin"}><ModernLayout><AddNotifications/></ModernLayout></ProtectedRoute>}/>
                <Route path="/cars/editcar" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><ModernLayout><EditCar/></ModernLayout></ProtectedRoute>}/>
                <Route path="/cars/editcar/:id" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><ModernLayout><EditCar/></ModernLayout></ProtectedRoute>}/>
                <Route path="/promos/editpromo" element={<ProtectedRoute permit={"admin"}><ModernLayout><EditPromo/></ModernLayout></ProtectedRoute>}/>
                <Route path="/promos/editpromo/:id" element={<ProtectedRoute permit={"admin"}><ModernLayout><EditPromo/></ModernLayout></ProtectedRoute>}/>
                <Route path="/cartypes/editcartype" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><ModernLayout><EditCarType/></ModernLayout></ProtectedRoute>} />
                <Route path="/cartypes/editcartype/:id" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><ModernLayout><EditCarType/></ModernLayout></ProtectedRoute>}/>
                <Route path="/*" element={<Error/>} />
                    <Route path="/" element={<LandingPage />} />
                  </Routes>
                </BrowserRouter>
              </AuthLoading>
            </ThemeProvider>
          </GoogleOAuthProvider>
        </FirebaseProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
